import ElasticAdapter from "api/DTOs/Common/ElasticSearch/ElasticAdapter";

export default function contactRechercheGlobaleAdapter(result: any = {}) {
  const elasticResult = ElasticAdapter.toBO(result);
  elasticResult.data = result.documents;
  elasticResult.total = result.total;
  return elasticResult;
}
